import _get from 'lodash/get';
import _noop from 'lodash/noop';
import { gdprCookies } from '@bedrock-rdk/config';
import { thirdPartyWithLayoutService } from '@bedrock/fido-sdk';
import { getAnalyticsEngines, getAnalyticsEvents } from '../app/app.selectors';
import { getRejectedConsents } from '../gdprNotice/gdprNotice.utils';
import { setInitialAttributes, getThirdPartyServicesConfigs, startEngines } from './analytics.utils';
import { CONSENT_TYPE_TO_ENGINE_MAP } from '../gdprNotice/gdprNotice.constants';

export const INITIALIZE_ENGINES = 'analytics/INITIALIZE_ENGINES';
export const initializeEngines = engines => ({
  type: INITIALIZE_ENGINES,
  engines,
});

export const ACCEPT_ENGINES = 'analytics/ACCEPT_ENGINES';
export const acceptEngines = engines => ({
  type: ACCEPT_ENGINES,
  engines,
});

export const initAnalyticsEngines = () => (dispatch, getState) => {
  const state = getState();
  // List of names of third party engines, available in current configuration
  const enabledEngines = getAnalyticsEngines(state);
  // NOTE: tagging plans are merged events of all enabled engines. The service uses them to create the eventFields
  // parameter for sendEvent and other functions.
  // Don't forget to pass taggingPlans (events) in the third party service initParams if we need them there
  const taggingPlans = getAnalyticsEvents(state);

  thirdPartyWithLayoutService.init({
    thirdParties: getThirdPartyServicesConfigs(enabledEngines),
    config: {
      taggingPlans,
    },
    options: { logger: _noop, sendErrorToMonitoring: _noop, isRecording: false },
  });

  return dispatch(initializeEngines(enabledEngines));
};

export const bootstrapEngines = () => async (dispatch, getState) => {
  const state = getState();
  const engines = getAnalyticsEngines(state);

  const rejectedConsents = getRejectedConsents(gdprCookies, _get(state, 'user.cookies', []));

  const acceptedEngines = [];
  const rejectedEngines = [];

  engines.forEach(key => {
    // TODO: figure out app behavior when one engine belongs to two or more categories
    const isThirdPartyRejected = rejectedConsents.some(consent =>
      _get(CONSENT_TYPE_TO_ENGINE_MAP, [consent], []).includes(key),
    );

    if (isThirdPartyRejected) {
      rejectedEngines.push(key);
    } else {
      acceptedEngines.push(key);
    }
  });

  // FIXME: fix this in the thirdPartyWithLayoutService
  const initializedEngines = thirdPartyWithLayoutService.thirdParties || [];
  initializedEngines
    .filter(({ name }) => acceptedEngines.includes(name))
    .forEach(engine => {
      engine.rejected = false;
    });

  await startEngines(acceptedEngines, rejectedEngines);

  setInitialAttributes(getState());

  return dispatch(acceptEngines(acceptedEngines));
};
